// components/FullscreenDialog.tsx
import React from 'react';

interface FullscreenDialogProps {
  onDismiss: () => void;
}

export const FullscreenDialog: React.FC<FullscreenDialogProps> = ({ onDismiss }) => {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center" aria-modal="true">
      <div className="bg-brand-surface rounded-lg shadow-xl p-6 w-full max-w-md">
        <h2 className="text-xl font-bold">Fullscreen Mode Enabled</h2>
        <p className="text-brand-text-secondary mt-2">
          For a secure test environment, fullscreen mode has been enabled.
        </p>
        <p className="text-red-500 font-semibold mt-2">
          Exiting fullscreen mode will cancel the test.
        </p>
        <div className="mt-6 flex justify-end">
          <button 
            onClick={onDismiss} 
            className="px-4 py-2 text-sm font-semibold text-white bg-brand-primary hover:bg-brand-primary-hover rounded-lg"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};
